import { colors } from '@material-ui/core';

import ProsarisLogoTopbar from 'src/assets/prosaris_white.svg';
import ProsarisLogoReport from 'src/assets/ProsarisLogoBlack.png';
import ProsarisFavicon from 'src/assets/favicon.svg';
import ProsarisCoverPageLogo from 'src/assets/prosaris_cover_page.png';

const prosarisBrandConfig = {
  urls: [],
  theme: {
    PRIMARY_COLOR: '#5e7ad2',
    PRIMARY_DARK: '#4B68C1',
    SECONDARY_COLOR: '#53565a',
    PRIMARY_TEXT: '#53565A',
    ACCENT_TEXT: '#ffffff',
    DARK_BACKGROUND: '#333740',
    SUCCESS: '#0D7B3B',
    WARNING: '#B29600',
    ERROR: '#BD1717',
    BRANDING_MAIN: '#5e7ad2',
    BRANDING_SHADE: '#4B68C1',
    MAIN_LAYOUT: {
      BACKGROUND: '#5e7ad2',
      PRIMARY_COLOR: '#5e7ad2',
      PRIMARY_DARK: '#4B68C1',
      SECONDARY_COLOR: '#5e7ad2',
      ACCENT_COLOR: '#3C56A3',
      TEXT_PRIMARY: '#333740',
      TEXT_SECONDARY: '#333740',
      INPUT_BACKGROUND: '#ffffff',
      INPUT_BORDER: '#333740',
      BUTTON_BACKGROUND: '#4B68C1',
      BUTTON_COLOR: '#ffffff',
      BUTTON_HOVER: '#3C56A3',
    },
    UNIT_TOGGLE_BUTTON: {
      ACTIVE: {
        BACKGROUND: '#5e7ad2',
        COLOR: '#ffffff',
        HOVER: {
          BACKGROUND: '#4B68C1',
          COLOR: '#ffffff',
        },
      },
      INACTIVE: {
        BACKGROUND: '#ffffff',
        COLOR: '#5e7ad2',
        HOVER: {
          BACKGROUND: colors.grey[100],
          COLOR: '#5e7ad2',
        },
      },
    },
    TOPBAR: {
      ACTIVE: {
        BACKGROUND: '#f3f6f8',
        COLOR: '#5e7ad2',
      },
      INACTIVE: {
        BACKGROUND: '#4b68c1',
        COLOR: '#ffffff',
      },
      TEXT: '#ffffff',
    },
  },
  logo: {
    login: {
      src: ProsarisLogoTopbar,
      height: 40,
      alt: 'Prosaris Logo',
    },
    topbar: {
      src: ProsarisLogoTopbar,
      height: 20,
      alt: 'Prosaris Logo',
    },
    report: {
      src: ProsarisLogoReport,
      height: 15,
      alt: 'Prosaris Logo',
    },
    coverPage: {
      src: ProsarisCoverPageLogo,
      height: 45,
      alt: 'Prosaris Logo',
    },
    favicon: {
      src: ProsarisFavicon,
    },
  },
  title: 'PROSARIS Dashboard',
  bannersEnabled: true,
  poweredByEnabled: false,
  ol1Enabled: true,
  overrideExistingRegistration: false,
  viewOnboardingProgress: false,
  companyInfo: {
    name: 'PROSARIS',
    email: 'support@prosaris.ca',
  },
};

export default prosarisBrandConfig;
